export default __webpack_public_path__ + "static/media/google_socialicon.1b8c038a.svg";